
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/touristroutes",
      function () {
        return require("private-next-pages/touristroutes/index.tsx");
      }
    ]);
  